// App.js
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DivisasProvider } from './contexts/DivisasContext';
import SonnerProvider from './components/SonnerProvider';
import './App.css';

// ✅ Carga diferida de páginas públicas
const Home = lazy(() => import('./pages/public/Home'));
const Servicios = lazy(() => import('./pages/public/Servicios'));
const Compra = lazy(() => import('./pages/public/Compra'));
const CompraPrueba = lazy(() => import('./pages/public/CompraPrueba'));
const BuscarReserva = lazy(() => import('./pages/public/BuscarReserva'));

// ✅ Carga diferida de páginas admin
const AdminLogin = lazy(() => import('./pages/admin/Login'));
const Dashboard = lazy(() => import('./pages/admin/Dashboard'));
const ServiciosAdmin = lazy(() => import('./pages/admin/ServiciosAdmin'));
const ReservasAdmin = lazy(() => import('./pages/admin/ReservasAdmin'));
const VentaDirecta = lazy(() => import('./pages/admin/VentaDirecta'));
const ItinerarioAdmin = lazy(() => import('./pages/admin/ItinerarioAdmin'));
const ConfiguracionAdmin = lazy(() => import('./pages/admin/ConfiguracionAdmin'));

// ✅ Fallback simple mientras se carga cada chunk
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 to-white">
    <div className="flex flex-col items-center gap-3">
      <div className="w-10 h-10 border-4 border-[#e83e8c] border-t-transparent rounded-full animate-spin"></div>
      <p className="text-gray-500 text-sm">Cargando...</p>
    </div>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

function AppRoutes() {
  const { admin, loading } = useAuth();
  if (loading) return <LoadingFallback />;

  return (
    <>
      <SonnerProvider />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/compra" element={<Compra />} />
          <Route path="/test-pdf" element={<CompraPrueba />} />
          <Route path="/buscar-reserva" element={<BuscarReserva />} />
          
          {/* Rutas admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute><Dashboard /></ProtectedRoute>
          } />
          <Route path="/admin/servicios" element={
            <ProtectedRoute><ServiciosAdmin /></ProtectedRoute>
          } />
          <Route path="/admin/reservas" element={
            <ProtectedRoute><ReservasAdmin /></ProtectedRoute>
          } />
          <Route path="/admin/venta-directa" element={
            <ProtectedRoute><VentaDirecta /></ProtectedRoute>
          } />
          <Route path="/admin/itinerario" element={
            <ProtectedRoute><ItinerarioAdmin /></ProtectedRoute>
         } />
          <Route path="/admin/configuracion" element={
            <ProtectedRoute><ConfiguracionAdmin /></ProtectedRoute>
          } />
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </>
  );
}

function App() {
  return (
    <Router>
      <DivisasProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </DivisasProvider>
    </Router>
  );
}

export default App;